import { Box } from "@garther/ui/components";
import { Info } from "lucide-react";

import { TranslateFn } from "../../libs/utils/type";

interface QuizHelpProps {
  title?: string;
  description?: string;
  t: TranslateFn;
}

export default function QuizHelp({ title, description, t }: QuizHelpProps) {
  // Use provided title/description or fallback to translations
  const displayTitle = title || t("quiz.help.title");
  const displayDescription = description || t("quiz.help.description");

  return (
    <Box className="bg-background-primary border border-border-dark">
      <div className="flex items-start space-x-4">
        <Info className="w-7 h-7 text-text-primary" />
        <div>
          <h3 className="text-text-primary font-normal text-responsive-2xl mb-2">{displayTitle}</h3>
          <p className="text-text-secondary text-responsive-base leading-relaxed">{displayDescription}</p>
        </div>
      </div>
    </Box>
  );
}
